var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-hidden h-200"},[_c('ScoreBoard'),_c('Scene',{staticClass:"flex-grow"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }